module.exports = __webpack_public_path__ + "img/disconnected.6d6be0fe.png";